/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, useLocation } from 'react-router-dom';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { Grid, DialogContentText } from '@material-ui/core';
import moment from 'moment';
import UsuarioModal from './UsuarioModal';
import StatusModal from './StatusModal';
import SimilarityModal from './SimilarityModal';
import {
  Input,
  Widget,
  NsirStatusSelect,
  NsirSyncStatusSelect,
  Dropzone,
  DialogDefault,
  OptionSelect,
  UploadDialog,
  SimNaoSelect,
} from '../../components';
import * as Roles from '../../constants/role';
import * as Status from '../../constants/status';
import * as actionsNsirs from '../../store/nsir/actions';
import * as selectorsAuth from '../../store/auth/reducer';
import * as actionsToast from '../../store/toast/actions';
import { importUsoMutuo } from '../../store/nsmp/actions';
import * as selectorsModuleConfiguration from '../../store/moduleConfiguration/reducer';
import * as selectorsNsirs from '../../store/nsir/reducer';
import * as selectorsAlimentador from '../../store/alimentador/reducer';
import { NSIR_STATUS_UPDATE } from 'constants/modules';
import { isInspecaoMtBt, isUsuarioUsoMuto, isUsoMutuo, buildRequiredSchema, isTrue, isNullOrUndefined, isInspecaoFibraOpticaOuProjetoObras } from 'utils';
import {
  podePersistirAuditoria,
  situacaoPermiteEdicaoAuditoria,
  isRoleAuditoriaNsir
} from '../../helpers/auditoriaNsirPermission';
import { buildNsirDocumentoKmzFileName } from '../../utils/nsirDocumentoKmzName';
import InformacaoBasicaForm from './informacao-basica/InformacaoBasicaForm';
import ProjetoObrasFibraOpticaForm from './informacao-basica/ProjetoObrasFibraOpticaForm';
import UsoMutuoForm from './informacao-basica/UsoMutuoForm';
import * as XLSX from 'xlsx';

const useStyles = makeStyles(theme => ({
  gridContainer: {
    padding: theme.spacing(2),
    paddingTop: 20,
    paddingBottom: 30
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const InformacaoBasicaTab = ({
  nsir,
  onSave,
  authData,
  generateNsirReportById,
  updateStatus,
  iniciarDigitacaoNsir,
  trocarDigitadorNsir,
  exportCcsm,
  messageError,
  messageWarning,
  importUsoMutuo,
  forceUpdateStatusNsir,
  moduleConfigurations,
  history,
  similarityResults,
  similarityPendingData,
  clearSimilarity,
  saveNsirForce,
  alimentadoresOptions,
  patchNsirAuditoria,
}) => {
  const classes = useStyles();

  const [statusModal, setStatusModal] = useState(false);
  const [atualizarStatusModal, setAtualizarStatusModal] = useState({ open: false, defaultStatus: null });
  const [openCcsm, setOpenCcsm] = useState(false);
  const [inspetorModal, setInspetorModal] = useState({ open: false, isChange: false });
  const [digitadorModal, setDigitadorModal] = useState({ open: false, isChange: false });
  const [digitacaoFinalizadaError, setDigitacaoFinalizadaError] = useState({ open: false, message: '' });
  const [errors, setErrors] = useState({});
  const [documentoKmz, setDocumentoKmz] = useState(null);
  const [openImportPostes, setOpenImportPostes] = useState(false);
  const [openSimilarityModal, setOpenSimilarityModal] = useState(false);
  const [modoEdicaoAuditoriaNsir, setModoEdicaoAuditoriaNsir] = useState(false);
  const [values, setValues] = useState({
    vencimento: moment().valueOf(),
    status: 'EM_CRIACAO',
    inspecaoTermografica: false,
  });

  const location = useLocation();

  useEffect(() => {
    clearSimilarity();
  }, []);

  useEffect(() => {
    if (nsir && nsir.id) {
      setValues({
        ...nsir,
        vencimento: moment(nsir.vencimento)
          .locale('ptBR')
          .toISOString()
      });
      if (nsir.documentoKmzFile) {
        setDocumentoKmz(nsir.documentoKmzFile);
      }
    }
  }, [nsir]);

  useEffect(() => {
    if (nsir && !nsir.id && Array.isArray(similarityResults) && similarityResults.length > 0) {
      setOpenSimilarityModal(true);
    } else {
      setOpenSimilarityModal(false);
    }
  }, [nsir, similarityResults]);

  useEffect(() => {
    if (!situacaoPermiteEdicaoAuditoria(values.status)) {
      setModoEdicaoAuditoriaNsir(false);
    }
  }, [values.status]);

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const canAtualizarStatus = () => moduleConfigurations?.some(m => m.codigo === NSIR_STATUS_UPDATE && m.userId === authData.id);

  const isDigitador = () => !isUsuarioUsoMuto(authData.email) && authData && authData.role === Roles.DIGITADOR && values.status === Status.EM_DIGITACAO && values.digitadorId === authData.id;
  const isInspetor = () => !isUsuarioUsoMuto(authData.email) && authData && authData.role === Roles.INSPETOR;
  const isAdmin = () => !isUsuarioUsoMuto(authData.email) && authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);
  const podeEditarAuditoriaNsir = () => {
    if (isUsuarioUsoMuto(authData.email) || !authData) return false;
    return podePersistirAuditoria({
      role: authData.role,
      nsirStatus: values.status,
      modoEdicaoAuditoria: modoEdicaoAuditoriaNsir
    });
  };
  const usuarioCroquiPodeEditar = () => !isUsuarioUsoMuto(authData.email) && authData && authData.role === Roles.CROQUI && (values.status === Status.EM_CRIACAO || values.status === Status.AGUARDANDO_INSPECAO);

  const getActions = () => {
    const errors = validate(nsir, getSchema(nsir));
    const isValid = errors === undefined || (errors && Object.keys(errors).length === 0 && errors.constructor === Object);

    const actions = [
      {
        onClick: () => setOpenImportPostes(true),
        title: 'Adicionar Postes',
        show: values.id !== undefined && (values.status === Status.EM_CRIACAO || values.status === Status.AGUARDANDO_INSPECAO) && isAdmin() && isValid && isUsoMutuo(values.tipoServicoId)
      },
      {
        onClick: () => setAtualizarStatusModal({ open: true, defaultStatus: values.status }),
        title: 'Atualizar Status',
        show: !!values.id && canAtualizarStatus()
      },
      {
        onClick: () => setInspetorModal({ open: true, isChange: false }),
        title: 'Publicar para Inspeção',
        show: values.id !== undefined && values.status === Status.EM_CRIACAO && isAdmin() && isValid
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.EM_INSPECAO,
          inspetorId: values.inspetorId,
        }),
        title: 'Iniciar Inspeção',
        show:
          values.status === Status.AGUARDANDO_INSPECAO &&
          values.inspetorId === authData.id
      },
      {
        onClick: () => setInspetorModal({ open: true, isChange: true }),
        title: 'Trocar Inspetor',
        show: (values.status === Status.AGUARDANDO_INSPECAO || values.status === Status.INSPECAO_ENVIADA_PARCIAL) && isAdmin()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.INSPECAO_FINALIZADA,
        }),
        title: 'Finalizar Inspeção com Error',
        show: [Status.INSPECAO_EM_ENVIO, Status.INSPECAO_SYNC_ERROR, Status.ERRO_AO_ENVIAR_INSPECAO].includes(values.status) && isAdmin()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.INSPECAO_FINALIZADA,
          inspetorId: values.inspetorId,
        }),
        title: 'Finalizar Inspeção',
        show: (values.status === Status.EM_INSPECAO || values.status === Status.INSPECAO_ENVIADA_PARCIAL) && (values.inspetorId === authData.id || isAdmin())
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.AGUARDANDO_INSPECAO,
          inspetorId: values.inspetorId,
        }),
        title: 'Reabrir Inspeção',
        show: isAdmin() && (values.status === Status.INSPECAO_FINALIZADA || values.status === Status.AGUARDANDO_DIGITACAO
          || values.status === Status.EM_DIGITACAO)
      },
      {
        onClick: () => setDigitadorModal({ open: true, isChange: false }),
        title: 'Publicar para Digitação',
        show: values.status === Status.INSPECAO_FINALIZADA && isAdmin() && isValid
      },
      {
        onClick: () => iniciarDigitacaoNsir({
          id: values.id,
          digitadorId: authData.id
        }),
        title: 'Iniciar Digitação',
        show: Status.canDigitar(values.status) && (values.digitadorId === authData.id || values.digitadorId === null)
      },
      {
        onClick: () => setDigitadorModal({ open: true, isChange: true }),
        title: 'Trocar Digitador',
        show: values.status === Status.AGUARDANDO_DIGITACAO && isAdmin()
      },
      {
        onClick: () => trocarDigitadorNsir({ id: values.id, digitadorId: null }),
        title: 'Remover Digitador',
        show: (values.status === Status.AGUARDANDO_DIGITACAO || values.status === Status.EM_DIGITACAO) && values.digitadorId && isAdmin()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.DIGITACAO_FINALIZADA,
          inspetorId: values.inspetorId,
        }, (open, message) => setDigitacaoFinalizadaError({ open, message })),
        title: 'Finalizar Digitação',
        show: values.status === Status.EM_DIGITACAO && (values.digitadorId === authData.id || isAdmin())
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.AGUARDANDO_DIGITACAO,
          inspetorId: values.inspetorId,
        }),
        title: 'Reabrir Digitação',
        show: values.status === Status.DIGITACAO_FINALIZADA && isAdmin()
      },
      {
        onClick: () => generateNsirReportById(values),
        title: 'Gerar Relatório',
        show: !!values.id && (values.digitadorId === authData.id || isAdmin() || isUsuarioUsoMuto(authData.email))
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.EXECUTADA_GDIS,
          inspetorId: values.inspetorId,
        }),
        title: 'Concluir NSIR',
        show: values.status === Status.DIGITACAO_FINALIZADA && isAdmin()
      },
      {
        onClick: () => setModoEdicaoAuditoriaNsir(v => !v),
        title: modoEdicaoAuditoriaNsir ? 'Encerrar auditoria' : 'Auditoria',
        show:
          !!values.id &&
          !isUsuarioUsoMuto(authData.email) &&
          isRoleAuditoriaNsir(authData.role) &&
          isInspecaoMtBt(values.tipoServicoId) &&
          situacaoPermiteEdicaoAuditoria(values.status)
      },
      {
        onClick: () => setOpenCcsm(true),
        title: 'CCSM',
        show: (values.status === Status.DIGITACAO_FINALIZADA || values.status === Status.EXECUTADA_GDIS) && isAdmin()
      },
      {
        onClick: () => setStatusModal(true),
        title: 'Reabrir NSIR',
        show: values.status === Status.EXECUTADA_GDIS && isAdmin()
      },
      {
        onClick: () => onSaveLocal(),
        title: 'Salvar',
        show: isAdmin() || (values.status === Status.EM_INSPECAO && values.inspetorId === authData.id) || usuarioCroquiPodeEditar()
      },
    ];

    return actions;
  };

  const onAddPostes = files => {
    const reader = new FileReader();

    reader.onload = e => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 }).slice(1).filter(d => d.length > 0);
      if (excelData.length === 0) {
        messageWarning({ message: 'A planilha não possui postes para serem importados!' });
        return null;
      }

      const data = excelData.map((item) => {
        return {
          municipio: item[0],
          codigo: item[2],
          numeroPoste: item[2],
          endereco: `${item[3]}, ${item[4]} - ${item[5]}`,
          rua: item[3],
          numero: item[4],
          bairro: item[5],
          latitude: item[6],
          longitude: item[7],
          fotoInicio: false,
          fotoFim: false,
          analiseRisco: false,
          fotoRegistro: false,
        }
      });
      importUsoMutuo(values.id, data, () => {
        const targetPath = `/nsir/${values.id}`;
        if (location.pathname === targetPath) {
          window.location.reload();
        } else {
          history.push(targetPath);
        }
      });
    };

    reader.onerror = function() {
      messageError({ message: 'Erro ao abrir a planilha. Por favor, tente novamente!' });
    };
  
    reader.readAsBinaryString(files[0]);
  }

  const getSchema = data => {
    if (isUsoMutuo(data.tipoServicoId)) {
      return buildRequiredSchema(['tipoServicoId', 'clienteId', 'codigo', 'malhaId', 'km', 'possuiOficio', 'prioridade', 'newFlow', 'pausada']);
    }
    if (isInspecaoFibraOpticaOuProjetoObras(data.tipoServicoId)) {
      return buildRequiredSchema(['area', 'equipamento', 'codigo', 'malhaId', 'prioridade', 'inspecaoTermografica', 'tipoServicoId', 'clienteId']);
    }
    const schema = buildRequiredSchema(['area', 'equipamento', 'codigo', 'malhaId', 'prioridade', 'anomalia', 'inspecaoTermografica', 'tipoServicoId', 'clienteId']);
    if (isInspecaoMtBt(data.tipoServicoId)) {
      return {
        ...schema,
        ...buildRequiredSchema(['subtipoId'])
      };
    }
    return schema;
  };

  const onSaveLocal = () => {
    const errors = validateRequiredFields(values);
    if (
      errors === undefined ||
      (errors &&
        Object.keys(errors).length === 0 &&
        errors.constructor === Object)
    ) {
      onSave(isUsoMutuo(values.tipoServicoId) ? { ...values, equipamento: '' } : values);
    }
  };

  const validateCoordenadas = data => {
    if (isInspecaoFibraOpticaOuProjetoObras(data.tipoServicoId)) {
      return {};
    }
    let errors = {};

    if (data.latitude && (data.latitude.trim().length !== 9 || !data.latitude.match(/\d{2}(,\d{6})?/))) {
      errors = { ...errors, latitude: ['O Campo é inválido'] };
    }

    if (data.longitude && (data.longitude.trim().length !== 9 || !data.longitude.match(/\d{2}(,\d{6})?/))) {
      errors = { ...errors, longitude: ['O Campo é inválido'] };
    }

    return errors;
  }

  const validateAdere = data => {
    if (!isInspecaoMtBt(data.tipoServicoId)) return {};
    
    if (isNullOrUndefined(data.possuiAdere)) { 
      return { possuiAdere: ['O Campo é inválido'] };
    }

    if (isTrue(data.possuiAdere) && isNullOrUndefined(data.adereMonth)) {
      return { adereMonth: ['O Campo é inválido'] };
    } 

    return {};
  }

  const validateRequiredFields = data => {
    const currentErrors = { ...validate(data, getSchema(data)), ...validateCoordenadas(data), ...validateAdere(data) };
    setErrors(currentErrors);
    return currentErrors;
  };

  return (
    <>
      <Widget title="Informações Básicas" actions={getActions()} insideTab>
        <Grid container spacing={3} className={classes.gridContainer}>
          <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <OptionSelect
              label="Tipo de Serviço"
              codigo="TIPO_SERVICO"
              isRequired
              onSelect={value => {
                const fibraOpticaOuProjetos = isInspecaoFibraOpticaOuProjetoObras(value);
                setValues({
                  ...values,
                  tipoServicoId: value,
                  subtipoId: null,
                  ...(fibraOpticaOuProjetos
                    ? {
                      anomalia: null,
                      gerenciaId: null,
                      poloId: null,
                      subestacaoId: null,
                      alimentadorId: null,
                      latitude: null,
                      longitude: null,
                      situacao: null
                    }
                    : {}),
                });
                setErrors({});
              }}
              value={values.tipoServicoId}
              disabled={!isAdmin()}
              error={errors && errors.tipoServicoId ? true : false}
            />
          </Grid>
          {!isUsoMutuo(values.tipoServicoId) && !isInspecaoFibraOpticaOuProjetoObras(values.tipoServicoId) && <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <OptionSelect
              label="Subtipo da Inspeção"
              codigo="NSIR_SUBTIPOS"
              isRequired={isInspecaoMtBt(values?.tipoServicoId)}
              onSelect={value => setValues({
                ...values,
                subtipoId: value
              })}
              value={values.subtipoId}
              disabled={!isAdmin() || !isInspecaoMtBt(values?.tipoServicoId)}
              error={errors && errors.subtipoId ? true : false}
            />
          </Grid>}
          <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <OptionSelect
              label="Cliente"
              codigo="CLIENTE"
              isRequired
              onSelect={value => setValues({
                ...values,
                clienteId: value
              })}
              value={values.clienteId}
              disabled={!isAdmin()}
              error={errors && errors.clienteId ? true : false}
            />
          </Grid>
          {isUsoMutuo(values.tipoServicoId) && <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <SimNaoSelect
              error={errors && errors.possuiOficio ? true : false}
              label="Possui Ofício"
              name="possuiOficio"
              onChange={handleChange}
              value={values.possuiOficio}
              disabled={!isAdmin()}
              isRequired
            />
          </Grid>}
          <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <Input label="Criado Por" disabled value={values.criadoPor} />
          </Grid>
          <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <NsirStatusSelect value={values.status} disabled />
          </Grid>
          <Grid item xs={6} sm={2} className={classes.fieldContainer}>
            <NsirSyncStatusSelect value={values.syncStatus} disabled />
          </Grid>
          {!isUsoMutuo(values.tipoServicoId) && !isInspecaoFibraOpticaOuProjetoObras(values.tipoServicoId) && (
            <InformacaoBasicaForm
              values={values}
              setValues={setValues}
              handleChange={handleChange}
              errors={errors}
              isAdmin={isAdmin()}
              usuarioCroquiPodeEditar={usuarioCroquiPodeEditar()}
              podeEditarAuditoria={podeEditarAuditoriaNsir()}
              patchNsirAuditoria={patchNsirAuditoria}
            />
          )}
          {isInspecaoFibraOpticaOuProjetoObras(values.tipoServicoId) && (
            <ProjetoObrasFibraOpticaForm
              values={values}
              setValues={setValues}
              handleChange={handleChange}
              errors={errors}
              isAdmin={isAdmin()}
              usuarioCroquiPodeEditar={usuarioCroquiPodeEditar()}
              podeEditarAuditoria={podeEditarAuditoriaNsir()}
              patchNsirAuditoria={patchNsirAuditoria}
            />
          )}
          {isUsoMutuo(values.tipoServicoId) && (
            <UsoMutuoForm
              values={values}
              setValues={setValues}
              handleChange={handleChange}
              errors={errors}
              isAdmin={isAdmin()}
              usuarioCroquiPodeEditar={usuarioCroquiPodeEditar()}
            />
          )}
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label="Croqui"
              name="documentoLink"
              onChange={handleChange}
              value={values.documentoLink}
              rows={2}
              multiline
              disabled={!isAdmin() && !usuarioCroquiPodeEditar()}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label="Observação do Croqui"
              name="observacaoCroqui"
              onChange={handleChange}
              value={values.observacaoCroqui || ''}
              rows={2}
              multiline
              disabled={!isAdmin() && !usuarioCroquiPodeEditar()}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label={isUsoMutuo(values.tipoServicoId) ? 'Observação do Lote' : 'Observação da NSIR'}
              name="observacao"
              onChange={handleChange}
              value={values.observacao}
              rows={2}
              multiline
              disabled={!isAdmin()}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label="Observação do Inspetor"
              name="observacaoInspetor"
              onChange={handleChange}
              value={values.observacaoInspetor}
              rows={2}
              multiline
              disabled={!isInspetor()}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label="Observação do Digitador"
              name="observacaoDigitador"
              onChange={handleChange}
              value={values.observacaoDigitador}
              rows={2}
              multiline
              disabled={!isDigitador()}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Dropzone
              buttonText="Adicionar Arquivo KMZ"
              filesLimit={1}
              acceptedFiles={['.kmz', '.pdf', '.xls', '.xlsb']}
              onSave={files => {
                if (files != null && files.length > 0) {
                  const rawFile = files[0];
                  const newName = buildNsirDocumentoKmzFileName(
                    {
                      codigo: values.codigo,
                      equipamento: values.equipamento,
                      alimentadorCodigo: values.alimentadorCodigo,
                      alimentadorId: values.alimentadorId,
                      alimentadoresOptions: alimentadoresOptions || [],
                    },
                    rawFile.name
                  );
                  const renamedFile = new File([rawFile], newName, { type: rawFile.type, lastModified: rawFile.lastModified });
                  setDocumentoKmz(renamedFile);
                  values.documentoKmzFile = renamedFile;
                  values.existDocumentoKmz = true;
                  values.documentoKmz = renamedFile.name;
                }
              }}
              disabled={!isAdmin() && !usuarioCroquiPodeEditar()}
              showGridFiles
              files={documentoKmz != null ? [{
                file: documentoKmz,
                nome: documentoKmz.name,
                onDelete: () => {
                  setDocumentoKmz(null);
                  values.documentoKmzFile = null;
                  values.existDocumentoKmz = false;
                  values.documentoKmz = null;
                  values.documentoKmzLink = null;
                }
              }] : []}
              canDeleteFiles={isAdmin() || usuarioCroquiPodeEditar()}
            />
          </Grid>
        </Grid>
      </Widget>
      <UsuarioModal
        grupos={[Roles.ADMIN, Roles.INSPETOR]}
        isDigitador={false}
        usuarioId={values.inspetorId}
        message={inspetorModal.isChange ? 'Alinhar com o inspetor antes de realizar a troca' : null}
        open={inspetorModal.open}
        handlerCancel={() => setInspetorModal({ open: false, isChange: false })}
        handlerConfirm={usuario => {
          setInspetorModal({ open: false, isChange: false });
          updateStatus({
            id: values.id,
            status: values.status === Status.INSPECAO_ENVIADA_PARCIAL ? Status.INSPECAO_ENVIADA_PARCIAL : Status.AGUARDANDO_INSPECAO,
            inspetorId: usuario,
            digitadorId: values.digitadorId
          });
        }}
      />
      <UsuarioModal
        grupos={[Roles.ADMIN, Roles.DIGITADOR]}
        isDigitador
        usuarioId={values.digitadorId}
        message={digitadorModal.isChange ? 'Alinhar com o digitador antes de realizar a troca' : null}
        open={digitadorModal.open}
        handlerCancel={() => setDigitadorModal({ open: false, isChange: false })}
        handlerConfirm={usuario => {
          setDigitadorModal({ open: false, isChange: false });
          trocarDigitadorNsir({ id: values.id, digitadorId: usuario });
        }}
      />
      <StatusModal
        open={statusModal}
        handlerCancel={() => setStatusModal(false)}
        handlerConfirm={status => {
          setStatusModal(false);
          updateStatus({
            id: values.id,
            status: status,
            inspetorId: values.inspetorId,
            digitadorId: values.digitadorId
          });
        }}
      />
      <StatusModal
        title="Atualizar Status"
        open={atualizarStatusModal.open}
        defaultStatus={atualizarStatusModal.defaultStatus}
        handlerCancel={() => setAtualizarStatusModal({ open: false, defaultStatus: null })}
        handlerConfirm={status => {
          setAtualizarStatusModal({ open: false, defaultStatus: null });
          forceUpdateStatusNsir(values.id, status);
        }}
      />
      <DialogDefault
        open={openCcsm}
        handlerCancel={() => setOpenCcsm(false)}
        handlerConfirm={() => {
          exportCcsm(values.id);
          setOpenCcsm(false);
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja exportar o relatório CCSM? </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={digitacaoFinalizadaError.open}
        readOnly
        handlerCancel={() => setDigitacaoFinalizadaError({ open: false, message: '' })}
        title="Erro"
      >
        <DialogContentText> {digitacaoFinalizadaError.message} </DialogContentText>
      </DialogDefault>
      <UploadDialog
        onClose={() => setOpenImportPostes(false)}
        onSave={onAddPostes}
        open={openImportPostes}
        acceptedFiles={['.xls','.xlsx']}
        dialogTitle="Importar Postes"
      />
      <SimilarityModal
        open={openSimilarityModal}
        results={similarityResults || []}
        onCancel={() => {
          setOpenSimilarityModal(false);
          clearSimilarity();
        }}
        onProceed={() => saveNsirForce(similarityPendingData, id => { history.push(`/nsir/${id}`) })}
      />
    </>
  );
};

InformacaoBasicaTab.propTypes = {
  onSave: PropTypes.func.isRequired,
  nsir: PropTypes.object.isRequired,
  authData: PropTypes.object.isRequired,
  generateNsirReportById: PropTypes.func.isRequired,
  updateStatus: PropTypes.func.isRequired,
  iniciarDigitacaoNsir: PropTypes.func.isRequired,
  trocarDigitadorNsir: PropTypes.func.isRequired,
  exportCcsm: PropTypes.func.isRequired,
  alimentadoresOptions: PropTypes.array,
  patchNsirAuditoria: PropTypes.func.isRequired,
};

InformacaoBasicaTab.defaultProps = {
  alimentadoresOptions: [],
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
  similarityResults: selectorsNsirs.getNsirSimilarityResults(state),
  similarityPendingData: selectorsNsirs.getNsirSimilarityPendingData(state),
  alimentadoresOptions: selectorsAlimentador.getAlimentadoresOptions(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsirs,
      ...actionsToast,
      importUsoMutuo
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InformacaoBasicaTab));
